import React, { useState, useEffect, useRef } from 'react';

// Logo URL - Replace with your own logo
// To use your own: put logo.png in public folder and change to "/logo.png"
const LOGO_URL = "https://raw.githubusercontent.com/idann111/idan/refs/heads/main/logo1.png";

// 15 Sample projects - replace with your actual projects
const sampleProjects = [
  {
    id: 1,
    title: "לחלוק או לגנוב",
    thumbnail: "https://img.youtube.com/vi/xcyCRs8GoZw/maxresdefault.jpg",
    youtubeId: "xcyCRs8GoZw",
    tags: ["אפטר", "תלת מימד"],
    views: "1.8M",
    description: "ערכתי את הפתיח של הסרטון, החלק הכי משמעותי וחשוב בו."
  },
  {
    id: 2,
    title: "לחלוק או לגנוב 2",
    thumbnail: "https://img.youtube.com/vi/4HgfWxT4AbQ/maxresdefault.jpg",
    youtubeId: "4HgfWxT4AbQ",
    tags: ["אפטר", "תלת מימד"],
    views: "1.5M",
    description: "ערכתי את הפתיח של הסרטון, החלק הכי משמעותי וחשוב בו."
  },
  {
    id: 3,
    title: "משחקי הגומי טיובס",
    thumbnail: "https://img.youtube.com/vi/MfktSPvhrHk/maxresdefault.jpg",
    youtubeId: "MfktSPvhrHk",
    tags: ["אפטר", "תלת מימד", "עיצוב"],
    views: "1.2M",
    description: "ערכתי את כל האפטר בסרטון וקטעי תלת, בנוסף לכך עיצבתי ועשיתי מושן דיזיין לאורך הסרטון"
  },
  {
    id: 4,
    title: "דוקו אינדה גיים", 
    thumbnail: "https://img.youtube.com/vi/wma8SFSOv4I/maxresdefault.jpg",
    youtubeId: "wma8SFSOv4I",
    tags: ["אפטר", "תלת מימד", "עיצוב"],
    views: "738K",
    description: "אפטר, תלת ועיצוב גרפי לאורך כל הסרטון."
  },
  {
    id: 5,
    title: "מתיחת אמונג אס",
    thumbnail: "https://img.youtube.com/vi/IhM5uFVbC94/maxresdefault.jpg",
    youtubeId: "IhM5uFVbC94",
    tags: ["אפטר", "עריכה כוללת", "עיצוב גרפי"],
    views: "429K",
    description: "עריכה כוללת של הסרטון, עם אפטר, סרטון מאוד מסובך עם אפטר בכמות מאוד גדולה"
  },
  {
    id: 6,
    title: "ביקורת מסעדות",
    thumbnail: "https://img.youtube.com/vi/8Gj5B6zTzQs/maxresdefault.jpg",
    youtubeId: "8Gj5B6zTzQs",
    tags: ["אפטר", "עריכה כוללת"],
    views: "691K",
    description: "עריכה כוללת של הסרטון, עם אפטר"
  },
  {
    id: 7,
    title: "וולוג טורקיה",
    thumbnail: "https://img.youtube.com/vi/k65XZp5n7lo/maxresdefault.jpg",
    youtubeId: "k65XZp5n7lo",
    tags: ["אפטר", "עריכה כוללת", "תלת"],
    views: "412K",
    description: "עריכה כוללת של הסרטון, עם אפטר ותלת"
  },
  {
    id: 8,
    title: "ביקורות המבורגרים",
    thumbnail: "https://img.youtube.com/vi/RaoKhmAvrcY/maxresdefault.jpg",
    youtubeId: "RaoKhmAvrcY",
    tags: ["אפטר", "עריכה כוללת"],
    views: "511K",
    description: "עריכה כוללת של הסרטון, עם אפטר"
  },
  {
    id: 9,
    title: "חזרה לבית ספר",
    thumbnail: "https://img.youtube.com/vi/y_ZbHRd21oU/maxresdefault.jpg",
    youtubeId: "y_ZbHRd21oU",
    tags: ["אפטר", "עריכה כוללת"],
    views: "837K",
    description: "עריכה של הסרטון, עם אפטר"
  },
  {
    id: 10,
    title: "מערכון קצר",
    thumbnail: "https://img.youtube.com/vi/rFLD61FNyXI/maxresdefault.jpg",
    youtubeId: "rFLD61FNyXI",
    tags: ["אפטר", "עיצוב גרפי"],
    views: "21K",
    description: "עיצוב ואנימצייה באפטר לסרטון"
  },
  {
    id: 11,
    title: "סרטון גיימינג",
    thumbnail: "https://img.youtube.com/vi/GJo4e60NJf0/maxresdefault.jpg",
    youtubeId: "GJo4e60NJf0",
    tags: ["אפטר", "עריכה כוללת"],
    views: "288K",
    description: "עריכה כוללת של הסרטון, עם אפטר"
  },
  {
    id: 12,
    title: "קליפ לשיר",
    thumbnail: "https://images.genius.com/aac1671190a22e31e0174ca818c0be21.1000x1000x1.jpg",
    instagramId: "DRr18NMiM1Q",
    platform: "instagram",
    tags: ["אפטר"],
    views: "48K",
    description: "עריכה של קליפ, הכוללת אפטר ותלת מימד"
  },
  {
    id: 13,
    title: "חבילת עריכה",
    thumbnail: "https://img.youtube.com/vi/b4_V8DJQpDM/maxresdefault.jpg",
    youtubeId: "b4_V8DJQpDM",
    tags: ["אפטר", "תלת מימד", "עיצוב"],
    views: "1.5K",
    description: "חבילת עריכה שלמה לעורכי וידאו וגם עריכת הטיזר"
  },
  {
    id: 14,
    title: "ביקורת מסעדות",
    thumbnail: "https://img.youtube.com/vi/5ApiVhYZk9o/maxresdefault.jpg",
    youtubeId: "5ApiVhYZk9o",
    tags: ["אפטר", "עריכה כוללת", "תלת"],
    views: "373K",
    description: "עריכה כוללת של הסרטון, עם אפטר ותלת"
  },
  {
    id: 15,
    title: "ניסוי חברתי",
    thumbnail: "https://img.youtube.com/vi/eJARxORnPZc/maxresdefault.jpg",
    youtubeId: "eJARxORnPZc",
    tags: ["אפטר", "עריכה כוללת"],
    views: "880K",
    description: "עריכה כוללת של הסרטון, עם אפטר"
  }
];


// 20 Clients/collaborators - 5 rows x 4 people
const clients = [
  { id: 1, name: "אינדה גיים", image: "/images/1.jpg" },
  { id: 2, name: "רונן ג'יג'י", image: "/images/2.jpg" },
  { id: 3, name: "דה כהן", image: "/images/3.jpg" },
  { id: 4, name: "בן קיסר", image: "/images/4.jpg" },
  { id: 5, name: "סייקניק", image: "/images/5.jpg" },
  { id: 6, name: "פריזי", image: "/images/6.jpg" },
  { id: 7, name: "דילן דרור", image: "/images/7.jpg" },
  { id: 8, name: "שון שואו", image: "/images/8.jpg" },
  { id: 9, name: "מאסטר אוהד", image: "/images/9.jpg" },
  { id: 10, name: "חמוצי", image: "/images/10.jpg" },
  { id: 11, name: "איציק ראובן", image: "/images/11.jpg" },
  { id: 12, name: "נתי קנטור", image: "/images/12.jpeg" },
];

// All programs
const allPrograms = [
  "Premiere Pro", "Photoshop", "Blender", "Cinema 4D", 
  "After Effects"
];

// Interactive Logo Component - rotates to follow cursor anywhere on screen
const InteractiveLogo = ({ src }) => {
  const [transform, setTransform] = useState({ rotateX: 0, rotateY: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const mouseX = e.clientX - centerX;
      const mouseY = e.clientY - centerY;
      
      // Subtle 3D tilt effect - logo "looks at" cursor
      const rotateY = (mouseX / window.innerWidth) * 20;
      const rotateX = -(mouseY / window.innerHeight) * 15;
      
      setTransform({ rotateX, rotateY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="hero-logo">
      <div 
        className="logo-3d-wrapper"
        style={{
          transform: `perspective(1000px) rotateX(${transform.rotateX}deg) rotateY(${transform.rotateY}deg)`
        }}
      >
        <img src={src} alt="Logo" draggable="false" />
      </div>
    </div>
  );
};

// Interactive Title Component - characters move away from cursor
const InteractiveTitle = ({ children, className = '' }) => {
  const containerRef = useRef(null);
  const [charPositions, setCharPositions] = useState([]);
  const chars = children.split('');
  
  useEffect(() => {
    setCharPositions(chars.map(() => ({ x: 0, y: 0 })));
  }, [children]);

  const handleMouseMove = (e) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    
    const charElements = containerRef.current.querySelectorAll('.interactive-char');
    const newPositions = [];
    
    charElements.forEach((charEl, index) => {
      const charRect = charEl.getBoundingClientRect();
      const charCenterX = charRect.left - rect.left + charRect.width / 2;
      const charCenterY = charRect.top - rect.top + charRect.height / 2;
      
      const distX = mouseX - charCenterX;
      const distY = mouseY - charCenterY;
      const distance = Math.sqrt(distX * distX + distY * distY);
      
      const maxDistance = 150;
      const maxMove = 25;
      
      if (distance < maxDistance) {
        const force = (1 - distance / maxDistance) * maxMove;
        const angle = Math.atan2(distY, distX);
        newPositions[index] = {
          x: -Math.cos(angle) * force,
          y: -Math.sin(angle) * force
        };
      } else {
        newPositions[index] = { x: 0, y: 0 };
      }
    });
    
    setCharPositions(newPositions);
  };

  const handleMouseLeave = () => {
    setCharPositions(chars.map(() => ({ x: 0, y: 0 })));
  };

  return (
    <span 
      ref={containerRef}
      className={`interactive-title ${className}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {chars.map((char, index) => (
        <span
          key={index}
          className="interactive-char"
          style={{
            transform: charPositions[index] 
              ? `translate(${charPositions[index].x}px, ${charPositions[index].y}px)`
              : 'translate(0, 0)',
            display: char === ' ' ? 'inline' : 'inline-block',
          }}
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </span>
  );
};

// Button particles component
const ButtonParticles = ({ x, y, active }) => {
  const shapes = ['●', '■', '▲', '◆'];
  const particles = Array.from({ length: 8 }, (_, i) => ({
    id: i,
    shape: shapes[i % shapes.length],
    angle: (i * 45) * (Math.PI / 180),
    distance: 30 + Math.random() * 20,
    size: 6 + Math.random() * 6,
    delay: i * 0.02
  }));

  if (!active) return null;

  return (
    <div className="particles-container" style={{ left: x, top: y }}>
      {particles.map(p => (
        <span
          key={p.id}
          className="particle"
          style={{
            '--tx': `${Math.cos(p.angle) * p.distance}px`,
            '--ty': `${Math.sin(p.angle) * p.distance}px`,
            '--size': `${p.size}px`,
            '--delay': `${p.delay}s`
          }}
        >
          {p.shape}
        </span>
      ))}
    </div>
  );
};

// Custom cursor with blob
const CustomCursor = () => {
  const cursorRef = useRef(null);
  const cursorDotRef = useRef(null);
  const blobRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);
  const [shockwaves, setShockwaves] = useState([]);

  useEffect(() => {
    const cursor = cursorRef.current;
    const dot = cursorDotRef.current;
    const blob = blobRef.current;
    let mouseX = 0, mouseY = 0;
    let cursorX = 0, cursorY = 0;
    let blobX = 0, blobY = 0;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (dot) {
        dot.style.left = `${mouseX}px`;
        dot.style.top = `${mouseY}px`;
      }
    };

    const animate = () => {
      cursorX += (mouseX - cursorX) * 0.15;
      cursorY += (mouseY - cursorY) * 0.15;
      if (cursor) {
        cursor.style.left = `${cursorX}px`;
        cursor.style.top = `${cursorY}px`;
      }
      
      blobX += (mouseX - blobX) * 0.02;
      blobY += (mouseY - blobY) * 0.02;
      if (blob) {
        blob.style.left = `${blobX}px`;
        blob.style.top = `${blobY}px`;
      }
      
      requestAnimationFrame(animate);
    };

    const handleHover = (e) => {
      if (e.target.closest('[data-hover]')) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };

    const handleClick = (e) => {
      const id = Date.now();
      setShockwaves(prev => [...prev, { id, x: e.clientX, y: e.clientY }]);
      setTimeout(() => {
        setShockwaves(prev => prev.filter(sw => sw.id !== id));
      }, 600);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleHover);
    window.addEventListener('click', handleClick);
    animate();

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleHover);
      window.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <>
      <div ref={blobRef} className="cursor-blob" />
      <div ref={cursorRef} className={`cursor-ring ${isHovering ? 'hovering' : ''}`} />
      <div ref={cursorDotRef} className="cursor-dot" />
      {shockwaves.map(sw => (
        <div key={sw.id} className="shockwave" style={{ left: sw.x, top: sw.y }} />
      ))}
    </>
  );
};

// Navbar component
const Navbar = ({ visible }) => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['works', 'about'];
      for (const section of sections) {
        const el = document.getElementById(section);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 200 && rect.bottom >= 200) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`navbar ${visible ? 'visible' : ''}`}>
      <div className="navbar-content">
        <div className="navbar-logo" data-hover onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={LOGO_URL} alt="Logo" className="navbar-logo-img" />
        </div>
        <div className="navbar-links">
          <button 
            className={`nav-link ${activeSection === 'works' ? 'active' : ''}`}
            onClick={() => scrollTo('works')}
            data-hover
          >
            <span className="nav-link-text">העבודות שלי</span>
            <span className="nav-link-line" />
          </button>
          <button 
            className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
            onClick={() => scrollTo('about')}
            data-hover
          >
            <span className="nav-link-text">אודות</span>
            <span className="nav-link-line" />
          </button>
        </div>
      </div>
    </nav>
  );
};

// Pop button
const PopButton = ({ children, onClick, className = '' }) => {
  const [particles, setParticles] = useState({ active: false, x: 0, y: 0 });
  const buttonRef = useRef(null);

  const handleClick = (e) => {
    const rect = buttonRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    setParticles({ active: true, x, y });
    setTimeout(() => setParticles({ active: false, x: 0, y: 0 }), 500);
    
    if (onClick) onClick(e);
  };

  return (
    <button 
      ref={buttonRef}
      className={`pop-button ${className}`}
      onClick={handleClick}
      data-hover
    >
      {children}
      <ButtonParticles x={particles.x} y={particles.y} active={particles.active} />
    </button>
  );
};

// Video modal
const VideoModal = ({ project, onClose }) => {
  useEffect(() => {
    const handleEsc = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const isInstagram = project.platform === 'instagram';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} data-hover>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
        <div className="video-container">
          {isInstagram ? (
            <iframe
              src={`https://www.instagram.com/p/${project.instagramId}/embed`}
              title={project.title}
              allowFullScreen
            />
          ) : (
            <iframe
              src={`https://www.youtube.com/embed/${project.youtubeId}?autoplay=1&rel=0`}
              title={project.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
        <div className="modal-info">
          <h3>{project.title}</h3>
          <div className="modal-tags">
            {project.tags.map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
          <p>{project.description}</p>
        </div>
      </div>
    </div>
  );
};

// Project card
const ProjectCard = ({ project, index, onClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), index * 100);
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [index]);

  const handleClick = () => {
    // If Instagram, open in new tab
    if (project.platform === 'instagram') {
      window.open(`https://www.instagram.com/reel/${project.instagramId}/`, '_blank');
    } else {
      onClick();
    }
  };

  return (
    <div 
      ref={cardRef}
      className={`project-card ${isVisible ? 'visible' : ''} ${isPressed ? 'pressed' : ''}`}
      onClick={handleClick}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => setIsPressed(false)}
      data-hover
    >
      <div className="card-image">
        <img src={project.thumbnail} alt={project.title} loading="lazy" draggable="false" />
        <div className="card-overlay">
          <div className="play-button">
            {project.platform === 'instagram' ? (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            )}
          </div>
        </div>
        <div className="card-shine" />
        {/* Views badge */}
        <div className="views-badge">
          <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
          </svg>
          <span>{project.views}</span>
        </div>
      </div>
      <div className="card-content">
        <h3>{project.title}</h3>
        <div className="card-tags">
          {project.tags.map(tag => (
            <span key={tag} className="tag">{tag}</span>
          ))}
        </div>
        <p className="card-description">{project.description}</p>
      </div>
      <div className="card-motion-line" />
    </div>
  );
};

// Client circle - BIGGER
// Interactive Clients Grid with push-away effect
const ClientsGrid = ({ clients }) => {
  const gridRef = useRef(null);
  const circleRefs = useRef([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [positions, setPositions] = useState(clients.map(() => ({ x: 0, y: 0 })));
  const [showName, setShowName] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
    setShowName(index);
    
    // Calculate push positions for other circles
    const hoveredEl = circleRefs.current[index];
    if (!hoveredEl) return;
    
    const hoveredRect = hoveredEl.getBoundingClientRect();
    const hx = hoveredRect.left + hoveredRect.width / 2;
    const hy = hoveredRect.top + hoveredRect.height / 2;
    
    const newPositions = clients.map((_, i) => {
      if (i === index) return { x: 0, y: 0 };
      
      const el = circleRefs.current[i];
      if (!el) return { x: 0, y: 0 };
      
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      
      const dx = cx - hx;
      const dy = cy - hy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      
      if (dist < 250 && dist > 0) {
        const force = (1 - dist / 250) * 30;
        const angle = Math.atan2(dy, dx);
        return {
          x: Math.cos(angle) * force,
          y: Math.sin(angle) * force
        };
      }
      return { x: 0, y: 0 };
    });
    
    setPositions(newPositions);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
    setShowName(null);
    setPositions(clients.map(() => ({ x: 0, y: 0 })));
  };

  return (
    <div ref={gridRef} className="clients-grid-new">
      {clients.map((client, index) => {
        const isHovered = hoveredIndex === index;
        const pos = positions[index] || { x: 0, y: 0 };
        
        return (
          <div
            key={client.id}
            ref={el => circleRefs.current[index] = el}
            className="client-circle-new"
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            style={{
              transform: `translate(${pos.x}px, ${pos.y}px) scale(${isHovered ? 1.25 : 1})`,
              zIndex: isHovered ? 10 : 1,
              transitionDelay: isHovered ? '0s' : '0.05s'
            }}
            data-hover
          >
            <img src={client.image} alt={client.name} />
            {showName === index && (
              <div className="client-name-new">
                {client.name}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// About Section
const AboutSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={sectionRef} className={`about-section ${isVisible ? 'visible' : ''}`}>
      {/* Multiple liquid purple blobs throughout */}
      <div className="about-liquid-bg">
        {/* Top left blob */}
        <div className="liquid-blob blob-1"></div>
        {/* Center right blob */}
        <div className="liquid-blob blob-2"></div>
        {/* Bottom blob */}
        <div className="liquid-blob blob-3"></div>
        {/* Extra blob */}
        <div className="liquid-blob blob-4"></div>
      </div>

      <div className="about-container">
        {/* Title */}
        <div className="about-header">
          <span className="about-label">קצת עליי, הידע שלי, והאנשים שאיתם עבדתי.</span>
          <h2 className="about-title">
            <InteractiveTitle>אודות</InteractiveTitle>
          </h2>
        </div>

        {/* Programs */}
        <div className="programs-section">
          <div className="programs-line">
            {allPrograms.map((program, index) => (
              <span 
                key={program} 
                className="program-item" 
                style={{ '--delay': `${index * 0.03}s` }}
                data-hover
              >
                {program}
              </span>
            ))}
          </div>
        </div>

        {/* Clients - Interactive circles with push effect */}
        <div className="clients-section">
          <h3>עבדתי עם</h3>
          <ClientsGrid clients={clients} />
        </div>

        {/* Bio at bottom */}
        <div className="about-bio-section">
        <p className="about-bio">
          היי, אני עידן שביט, אפטריסט ועורך וידאו ותלת מקצועי כבר למעלה מ-5 שנים,
          <br />
          עבדתי עם המון יוצרי תוכן ברשת ולקחתי חלק מרכזי ומשמעותי באפטר
          <br />
          בהפקות גדולות וסרטונים מצליחים.
          <br />
          <br />
          בין העבודות שלי:
          <br />
          אפטר, תלת ועריכה לסרטוני יוטיוב מהמצליחים בישראל
          <br />
          סרטוני VTR על מסכים בהופעות בהיכל מנורה והיכל טוטו חולון
          <br />
          אפטר ותלת בקליפים וטיזרים לאמנים שונים
        </p>

        </div>
      </div>
    </section>
  );
};


// Main App
export default function AfterEffectsPortfolio() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [projects] = useState(sampleProjects);
  const [showNavbar, setShowNavbar] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const worksSection = document.getElementById('works');
      if (worksSection) {
        const rect = worksSection.getBoundingClientRect();
        setShowNavbar(rect.top < 100);
      }
      
      // Parallax
      if (heroRef.current) {
        const scrolled = window.scrollY;
        heroRef.current.style.transform = `translateY(${scrolled * 0.4}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (sectionId === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800;900&display=swap');

        :root {
          --bg-primary: #F0EBE3;
          --bg-secondary: #F7F4F0;
          --bg-card: #FFFFFF;
          --text-primary: #1a1a1a;
          --text-secondary: #5c5c5c;
          --accent-primary: #8B5CF6;
          --accent-light: #EDE9FE;
          --accent-lighter: #F5F3FF;
          --accent-dark: #6D28D9;
          --border-color: #E0DCD4;
          --radius-sm: 12px;
          --radius-md: 20px;
          --radius-lg: 32px;
          --radius-xl: 48px;
          --radius-full: 9999px;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        /* Purple Scrollbar */
        ::-webkit-scrollbar {
          width: 12px;
        }

        ::-webkit-scrollbar-track {
          background: var(--bg-primary);
        }

        ::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, var(--accent-primary), var(--accent-dark));
          border-radius: 10px;
          border: 3px solid var(--bg-primary);
        }

        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, var(--accent-dark), var(--accent-primary));
        }

        html {
          scrollbar-width: thin;
          scrollbar-color: var(--accent-primary) var(--bg-primary);
          scroll-behavior: smooth;
        }

        ::selection {
          background: var(--accent-primary);
          color: white;
        }

        body {
          font-family: 'Rubik', sans-serif;
          background: var(--bg-primary);
          color: var(--text-primary);
          direction: rtl;
          overflow-x: hidden;
          cursor: none;
          /* Disable all text selection by default */
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }

        /* Prevent image dragging */
        img {
          -webkit-user-drag: none;
          -khtml-user-drag: none;
          -moz-user-drag: none;
          -o-user-drag: none;
          user-drag: none;
          draggable: false;
        }

        /* Allow selection ONLY for descriptions */
        .hero-subtitle,
        .section-header p,
        .about-bio,
        .card-info p,
        .modal-info p,
        .project-description {
          user-select: text;
          -webkit-user-select: text;
          -moz-user-select: text;
          -ms-user-select: text;
        }

        /* Interactive title - no text selection */
        .interactive-title {
          display: inline-block;
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }

        .interactive-char {
          display: inline-block;
          transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
          will-change: transform;
        }

        /* Section headers - no selection */
        .section-header h2,
        .about-title,
        .clients-section h3 {
          user-select: none;
          -webkit-user-select: none;
        }

        /* Cursor blob */
        .cursor-blob {
          position: fixed;
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.12) 0%, rgba(139, 92, 246, 0.05) 40%, transparent 70%);
          border-radius: 50%;
          pointer-events: none;
          z-index: 0;
          transform: translate(-50%, -50%);
          filter: blur(60px);
          will-change: left, top;
        }

        .cursor-ring {
          position: fixed;
          width: 44px;
          height: 44px;
          border: 2px solid var(--accent-primary);
          border-radius: 50%;
          pointer-events: none;
          z-index: 9999;
          transform: translate(-50%, -50%);
          transition: width 0.3s ease, height 0.3s ease, background 0.3s ease, border-width 0.3s ease;
        }

        .cursor-ring.hovering {
          width: 64px;
          height: 64px;
          background: rgba(139, 92, 246, 0.1);
          border-width: 3px;
        }

        .cursor-dot {
          position: fixed;
          width: 8px;
          height: 8px;
          background: var(--accent-primary);
          border-radius: 50%;
          pointer-events: none;
          z-index: 9999;
          transform: translate(-50%, -50%);
        }

        .shockwave {
          position: fixed;
          width: 10px;
          height: 10px;
          border: 2px solid var(--accent-primary);
          border-radius: 50%;
          pointer-events: none;
          z-index: 9998;
          transform: translate(-50%, -50%);
          animation: shockwave 0.6s ease-out forwards;
        }

        @keyframes shockwave {
          0% { width: 10px; height: 10px; opacity: 1; border-width: 3px; }
          100% { width: 150px; height: 150px; opacity: 0; border-width: 1px; }
        }

        @media (max-width: 768px) {
          .cursor-ring, .cursor-dot, .shockwave, .cursor-blob { display: none; }
          body { cursor: auto; }
        }

        /* Button particles */
        .particles-container {
          position: absolute;
          pointer-events: none;
          z-index: 10;
        }

        .particle {
          position: absolute;
          color: var(--accent-primary);
          font-size: var(--size);
          animation: particleFly 0.5s ease-out forwards;
          animation-delay: var(--delay);
          opacity: 0;
        }

        @keyframes particleFly {
          0% { opacity: 1; transform: translate(0, 0) scale(1); }
          100% { opacity: 0; transform: translate(var(--tx), var(--ty)) scale(0); }
        }

        /* Pop button */
        .pop-button {
          position: relative;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1.25rem 2.5rem;
          background: linear-gradient(
            135deg,
            rgba(139, 92, 246, 0.9) 0%,
            rgba(109, 40, 217, 0.85) 100%
          );
          color: white;
          border: none;
          border-radius: var(--radius-full);
          font-family: inherit;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: none;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          overflow: visible;
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          box-shadow: 
            0 4px 20px rgba(139, 92, 246, 0.35),
            0 0 0 1px rgba(255, 255, 255, 0.1) inset,
            0 2px 0 rgba(255, 255, 255, 0.15) inset;
        }

        .pop-button:hover {
          transform: translateY(-4px) scale(1.02);
          box-shadow: 
            0 15px 40px rgba(139, 92, 246, 0.5),
            0 0 0 1px rgba(255, 255, 255, 0.2) inset,
            0 2px 0 rgba(255, 255, 255, 0.2) inset;
          background: linear-gradient(
            135deg,
            rgba(139, 92, 246, 1) 0%,
            rgba(109, 40, 217, 0.95) 100%
          );
        }

        .pop-button:active {
          transform: scale(0.95);
          transition: transform 0.1s ease;
        }

        .pop-button svg {
          width: 20px;
          height: 20px;
          transition: transform 0.3s ease;
        }

        .pop-button:hover svg {
          transform: translateY(3px);
        }

        /* Navbar - COMPACT centered */
        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          padding: 1rem 0;
          display: flex;
          justify-content: center;
          transform: translateY(-100%);
          opacity: 0;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          pointer-events: none;
        }

        .navbar.visible {
          transform: translateY(0);
          opacity: 1;
          pointer-events: auto;
        }

        .navbar-content {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.7) 0%,
            rgba(255, 255, 255, 0.4) 50%,
            rgba(255, 255, 255, 0.6) 100%
          );
          backdrop-filter: blur(30px) saturate(180%);
          -webkit-backdrop-filter: blur(30px) saturate(180%);
          border-radius: var(--radius-full);
          padding: 0.6rem 1.5rem;
          box-shadow: 
            0 8px 32px rgba(139, 92, 246, 0.12),
            0 2px 8px rgba(0, 0, 0, 0.06),
            inset 0 1px 1px rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(255, 255, 255, 0.6);
        }

        .navbar-logo {
          cursor: none;
          transition: transform 0.3s ease;
          display: flex;
          align-items: center;
        }

        .navbar-logo:hover {
          transform: scale(1.05);
        }

        .navbar-logo-img {
          height: 32px;
          width: auto;
        }

        .navbar-divider {
          width: 1px;
          height: 24px;
          background: linear-gradient(180deg, transparent, rgba(139, 92, 246, 0.3), transparent);
        }

        .navbar-links {
          display: flex;
          gap: 0.25rem;
        }

        .nav-link {
          position: relative;
          background: none;
          border: none;
          font-family: inherit;
          font-size: 0.9rem;
          font-weight: 500;
          color: var(--text-secondary);
          padding: 0.5rem 1rem;
          border-radius: var(--radius-full);
          cursor: none;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .nav-link:hover {
          color: var(--text-primary);
          background: var(--accent-lighter);
        }

        .nav-link:active {
          transform: scale(0.95);
        }

        .nav-link.active {
          color: var(--accent-primary);
          background: var(--accent-light);
        }

        .nav-link-text {
          position: relative;
          z-index: 1;
        }

        .nav-link-line {
          position: absolute;
          bottom: 6px;
          left: 50%;
          transform: translateX(-50%) scaleX(0);
          width: 16px;
          height: 2px;
          background: var(--accent-primary);
          border-radius: 2px;
          transition: transform 0.3s ease;
        }

        .nav-link:hover .nav-link-line,
        .nav-link.active .nav-link-line {
          transform: translateX(-50%) scaleX(1);
        }

        /* Hero Section */
        .hero {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          overflow: hidden;
          padding: 2rem;
        }

        .hero-bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 120%;
          z-index: 0;
        }

        .hero-gradient {
          position: absolute;
          width: 600px;
          height: 600px;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.15;
        }

        .hero-gradient-1 {
          top: -150px;
          right: -150px;
          background: var(--accent-primary);
          animation: floatSlow 18s ease-in-out infinite;
        }

        .hero-gradient-2 {
          bottom: -200px;
          left: -150px;
          background: var(--accent-dark);
          animation: floatSlow 22s ease-in-out infinite reverse;
        }

        @keyframes floatSlow {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(40px, -40px) scale(1.15); }
        }

        .hero-content {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        /* Interactive Logo - follows cursor */
        .hero-logo {
          width: 180px;
          height: 180px;
          margin-bottom: 2rem;
          opacity: 0;
          transform: scale(2.5);
          animation: logoZoomOut 1.4s cubic-bezier(0.22, 1, 0.36, 1) forwards 0.3s;
        }

        .logo-3d-wrapper {
          width: 100%;
          height: 100%;
          transition: transform 0.15s ease-out;
          transform-style: preserve-3d;
        }

        .logo-3d-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        @keyframes logoZoomOut {
          0% { opacity: 0; transform: scale(2.5); }
          100% { opacity: 1; transform: scale(1); }
        }

        .hero-subtitle {
          font-size: 1.1rem;
          color: var(--text-secondary);
          max-width: 400px;
          line-height: 1.7;
          margin-bottom: 2.5rem;
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.8s ease forwards 1.2s;
        }

        .start-button-wrapper {
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.8s ease forwards 1.5s;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .scroll-hint {
          position: absolute;
          bottom: 3rem;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
          opacity: 0;
          animation: fadeInUp 0.8s ease forwards 1.8s, float 2s ease-in-out infinite 2.5s;
        }

        .scroll-hint span {
          font-size: 0.75rem;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          color: var(--text-secondary);
        }

        .scroll-hint-line {
          width: 2px;
          height: 50px;
          background: linear-gradient(to bottom, var(--accent-primary), transparent);
          border-radius: 2px;
        }

        @keyframes float {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50% { transform: translateX(-50%) translateY(10px); }
        }

        /* Floating Shapes */
        .floating-shapes {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          pointer-events: none;
        }

        .shape {
          position: absolute;
          border-radius: 50%;
          opacity: 0.08;
        }

        .shape-1 {
          width: 80px;
          height: 80px;
          background: var(--accent-primary);
          top: 15%;
          left: 10%;
          animation: floatShape1 12s ease-in-out infinite;
        }

        .shape-2 {
          width: 120px;
          height: 120px;
          border: 2px solid var(--accent-primary);
          background: transparent;
          top: 25%;
          right: 15%;
          animation: floatShape2 15s ease-in-out infinite;
          opacity: 0.12;
        }

        .shape-3 {
          width: 60px;
          height: 60px;
          background: var(--accent-dark);
          bottom: 30%;
          left: 20%;
          animation: floatShape3 10s ease-in-out infinite;
        }

        .shape-4 {
          width: 40px;
          height: 40px;
          border: 2px solid var(--accent-dark);
          background: transparent;
          top: 60%;
          right: 25%;
          border-radius: 8px;
          animation: floatShape4 8s ease-in-out infinite;
          opacity: 0.15;
        }

        .shape-5 {
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, var(--accent-primary), var(--accent-dark));
          bottom: 20%;
          right: 10%;
          animation: floatShape5 14s ease-in-out infinite;
          opacity: 0.06;
        }

        .shape-6 {
          width: 50px;
          height: 50px;
          border: 2px solid var(--accent-primary);
          background: transparent;
          top: 40%;
          left: 5%;
          border-radius: 12px;
          animation: floatShape6 11s ease-in-out infinite;
          opacity: 0.12;
        }

        @keyframes floatShape1 {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          25% { transform: translate(30px, -20px) rotate(90deg); }
          50% { transform: translate(60px, 10px) rotate(180deg); }
          75% { transform: translate(20px, 30px) rotate(270deg); }
        }

        @keyframes floatShape2 {
          0%, 100% { transform: translate(0, 0) rotate(0deg) scale(1); }
          33% { transform: translate(-40px, 30px) rotate(120deg) scale(1.1); }
          66% { transform: translate(20px, -20px) rotate(240deg) scale(0.9); }
        }

        @keyframes floatShape3 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(40px, -40px) scale(1.2); }
        }

        @keyframes floatShape4 {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          50% { transform: translate(-30px, 20px) rotate(180deg); }
        }

        @keyframes floatShape5 {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          33% { transform: translate(-20px, -30px) rotate(45deg); }
          66% { transform: translate(30px, 20px) rotate(-45deg); }
        }

        @keyframes floatShape6 {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          25% { transform: translate(20px, 30px) rotate(45deg); }
          50% { transform: translate(-10px, 50px) rotate(90deg); }
          75% { transform: translate(-30px, 20px) rotate(135deg); }
        }

        /* Animated Lines */
        .hero-lines {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          pointer-events: none;
        }

        .hero-line {
          position: absolute;
          height: 2px;
          background: linear-gradient(90deg, transparent, var(--accent-primary), transparent);
          opacity: 0.15;
        }

        .line-1 {
          width: 200px;
          top: 20%;
          left: -200px;
          animation: lineMove1 8s ease-in-out infinite;
        }

        .line-2 {
          width: 150px;
          top: 50%;
          right: -150px;
          animation: lineMove2 10s ease-in-out infinite 2s;
        }

        .line-3 {
          width: 180px;
          bottom: 30%;
          left: -180px;
          animation: lineMove3 12s ease-in-out infinite 4s;
        }

        @keyframes lineMove1 {
          0% { left: -200px; opacity: 0; }
          10% { opacity: 0.2; }
          90% { opacity: 0.2; }
          100% { left: 100%; opacity: 0; }
        }

        @keyframes lineMove2 {
          0% { right: -150px; opacity: 0; }
          10% { opacity: 0.2; }
          90% { opacity: 0.2; }
          100% { right: 100%; opacity: 0; }
        }

        @keyframes lineMove3 {
          0% { left: -180px; opacity: 0; }
          10% { opacity: 0.2; }
          90% { opacity: 0.2; }
          100% { left: 100%; opacity: 0; }
        }

        /* Glowing Orbs */
        .glow-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(40px);
          pointer-events: none;
        }

        .glow-orb.orb-1 {
          width: 150px;
          height: 150px;
          background: var(--accent-primary);
          top: 10%;
          right: 20%;
          opacity: 0.12;
          animation: orbPulse1 6s ease-in-out infinite;
        }

        .glow-orb.orb-2 {
          width: 100px;
          height: 100px;
          background: var(--accent-dark);
          bottom: 25%;
          left: 15%;
          opacity: 0.1;
          animation: orbPulse2 8s ease-in-out infinite 2s;
        }

        .glow-orb.orb-3 {
          width: 80px;
          height: 80px;
          background: var(--accent-primary);
          top: 60%;
          right: 10%;
          opacity: 0.08;
          animation: orbPulse3 7s ease-in-out infinite 1s;
        }

        @keyframes orbPulse1 {
          0%, 100% { transform: scale(1); opacity: 0.12; }
          50% { transform: scale(1.3); opacity: 0.2; }
        }

        @keyframes orbPulse2 {
          0%, 100% { transform: scale(1); opacity: 0.1; }
          50% { transform: scale(1.4); opacity: 0.18; }
        }

        @keyframes orbPulse3 {
          0%, 100% { transform: scale(1); opacity: 0.08; }
          50% { transform: scale(1.2); opacity: 0.15; }
        }

        /* Projects Section */
        .projects-section {
          padding: 6rem 2rem;
          position: relative;
          z-index: 1;
        }

        .section-header {
          max-width: 1400px;
          margin: 0 auto 4rem;
          text-align: center;
        }

        .section-header h2 {
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 900;
          margin-bottom: 1rem;
        }

        .section-header p {
          font-size: 1.1rem;
          color: var(--text-secondary);
          max-width: 500px;
          margin: 0 auto;
        }

        /* Showreel Button */
        .showreel-container {
          display: flex;
          justify-content: center;
          margin-bottom: 3rem;
        }

        .showreel-button {
          position: relative;
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.25rem 2.5rem;
          background: linear-gradient(
            135deg,
            rgba(139, 92, 246, 1) 0%,
            rgba(109, 40, 217, 1) 100%
          );
          color: white;
          border: none;
          border-radius: var(--radius-full);
          font-family: inherit;
          font-size: 1.2rem;
          font-weight: 700;
          cursor: none;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          box-shadow: 
            0 10px 40px rgba(139, 92, 246, 0.4),
            0 0 0 0 rgba(139, 92, 246, 0.4);
          animation: showreelPulse 2s ease-in-out infinite;
        }

        @keyframes showreelPulse {
          0%, 100% { 
            box-shadow: 
              0 10px 40px rgba(139, 92, 246, 0.4),
              0 0 0 0 rgba(139, 92, 246, 0.4);
          }
          50% { 
            box-shadow: 
              0 15px 50px rgba(139, 92, 246, 0.5),
              0 0 0 10px rgba(139, 92, 246, 0);
          }
        }

        .showreel-button:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 
            0 20px 60px rgba(139, 92, 246, 0.5),
            0 0 0 0 rgba(139, 92, 246, 0);
          animation: none;
        }

        .showreel-button:active {
          transform: scale(0.98);
        }

        .showreel-icon {
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .showreel-icon svg {
          width: 20px;
          height: 20px;
          margin-right: -2px;
        }

        .showreel-button:hover .showreel-icon {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }

        .showreel-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          transform: skewX(-20deg);
          transition: left 0.6s ease;
        }

        .showreel-button:hover .showreel-shine {
          left: 150%;
        }

        .projects-grid {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
          gap: 2rem;
        }

        @media (max-width: 500px) {
          .projects-grid {
            grid-template-columns: 1fr;
          }
        }

        .project-card {
          background: linear-gradient(
            145deg,
            rgba(255, 255, 255, 0.95) 0%,
            rgba(255, 255, 255, 0.8) 100%
          );
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-radius: var(--radius-lg);
          overflow: hidden;
          position: relative;
          cursor: none;
          opacity: 0;
          transform: translateY(50px);
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 
            0 4px 24px rgba(0, 0, 0, 0.06),
            0 0 0 1px rgba(255, 255, 255, 0.8) inset;
          border: 1px solid rgba(255, 255, 255, 0.5);
        }

        .project-card.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .project-card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 
            0 30px 60px rgba(139, 92, 246, 0.18),
            0 0 0 1px rgba(139, 92, 246, 0.1) inset;
          border-color: rgba(139, 92, 246, 0.2);
        }

        .project-card.pressed {
          transform: translateY(-5px) scale(0.98);
        }

        .card-image {
          position: relative;
          aspect-ratio: 16/10;
          overflow: hidden;
          border-radius: var(--radius-lg) var(--radius-lg) 0 0;
        }

        .card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .project-card:hover .card-image img {
          transform: scale(1.08);
        }

        .card-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
          transform: skewX(-20deg);
          transition: left 0.6s ease;
        }

        .project-card:hover .card-shine {
          left: 150%;
        }

        .views-badge {
          position: absolute;
          bottom: 12px;
          left: 12px;
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          background: linear-gradient(
            135deg,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(0, 0, 0, 0.5) 100%
          );
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-radius: 20px;
          color: white;
          font-size: 0.8rem;
          font-weight: 600;
          border: 1px solid rgba(255, 255, 255, 0.1);
          z-index: 5;
          transition: all 0.3s ease;
        }

        .views-badge svg {
          opacity: 0.9;
        }

        .project-card:hover .views-badge {
          background: linear-gradient(
            135deg,
            rgba(139, 92, 246, 0.9) 0%,
            rgba(109, 40, 217, 0.8) 100%
          );
          border-color: rgba(255, 255, 255, 0.2);
          transform: scale(1.05);
        }

        .card-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(26, 26, 26, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: var(--radius-lg) var(--radius-lg) 0 0;
        }

        .project-card:hover .card-overlay {
          opacity: 1;
        }

        .play-button {
          width: 80px;
          height: 80px;
          border: 3px solid #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          transform: scale(0.8) rotate(-90deg);
          opacity: 0;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .play-button svg {
          width: 28px;
          height: 28px;
          margin-right: -3px;
        }

        .project-card:hover .play-button {
          transform: scale(1) rotate(0deg);
          opacity: 1;
          background: var(--accent-primary);
          border-color: var(--accent-primary);
        }

        .card-content {
          padding: 1.75rem;
        }

        .card-content h3 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 0.75rem;
          transition: color 0.3s ease;
        }

        .project-card:hover .card-content h3 {
          color: var(--accent-primary);
        }

        .card-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .tag {
          font-size: 0.75rem;
          font-weight: 500;
          padding: 0.4rem 0.9rem;
          background: linear-gradient(
            135deg,
            rgba(139, 92, 246, 0.15) 0%,
            rgba(139, 92, 246, 0.08) 100%
          );
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          color: var(--accent-dark);
          border-radius: var(--radius-full);
          border: 1px solid rgba(139, 92, 246, 0.2);
          transition: all 0.3s ease;
        }

        .project-card:hover .tag {
          background: linear-gradient(
            135deg,
            rgba(139, 92, 246, 0.9) 0%,
            rgba(109, 40, 217, 0.85) 100%
          );
          color: white;
          border-color: transparent;
          box-shadow: 0 2px 10px rgba(139, 92, 246, 0.3);
        }

        .card-description {
          font-size: 0.95rem;
          color: var(--text-secondary);
          line-height: 1.7;
        }

        .card-motion-line {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 0;
          height: 4px;
          background: linear-gradient(to left, var(--accent-primary), var(--accent-dark));
          border-radius: 0 0 var(--radius-lg) var(--radius-lg);
          transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .project-card:hover .card-motion-line {
          width: 100%;
        }

        /* About Section */
        .about-section {
          min-height: 100vh;
          padding: 6rem 2rem;
          position: relative;
          overflow: hidden;
          background: var(--bg-secondary);
          border-radius: var(--radius-xl) var(--radius-xl) 0 0;
          display: flex;
          align-items: center;
        }

        /* Multiple liquid purple blobs */
        .about-liquid-bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          z-index: 0;
          overflow: hidden;
        }

        .liquid-blob {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.4;
        }

        .blob-1 {
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.6) 0%, rgba(109, 40, 217, 0.3) 50%, transparent 70%);
          top: -150px;
          left: -150px;
          animation: blobFloat1 15s ease-in-out infinite;
        }

        .blob-2 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.5) 0%, rgba(109, 40, 217, 0.2) 50%, transparent 70%);
          top: 30%;
          right: -100px;
          animation: blobFloat2 18s ease-in-out infinite;
        }

        .blob-3 {
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.5) 0%, rgba(109, 40, 217, 0.3) 50%, transparent 70%);
          bottom: -200px;
          left: 20%;
          animation: blobFloat3 20s ease-in-out infinite;
        }

        .blob-4 {
          width: 350px;
          height: 350px;
          background: radial-gradient(circle, rgba(167, 139, 250, 0.5) 0%, rgba(139, 92, 246, 0.2) 50%, transparent 70%);
          bottom: 20%;
          right: 20%;
          animation: blobFloat4 12s ease-in-out infinite;
        }

        @keyframes blobFloat1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(50px, 30px) scale(1.1); }
          66% { transform: translate(-20px, 50px) scale(0.95); }
        }

        @keyframes blobFloat2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-40px, 40px) scale(1.15); }
          66% { transform: translate(30px, -30px) scale(0.9); }
        }

        @keyframes blobFloat3 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(60px, -40px) scale(1.05); }
          66% { transform: translate(-40px, 20px) scale(1.1); }
        }

        @keyframes blobFloat4 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(-30px, -30px) scale(1.2); }
        }

        .about-container {
          max-width: 900px;
          margin: 0 auto;
          width: 100%;
          position: relative;
          z-index: 1;
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .about-section.visible .about-container {
          opacity: 1;
          transform: translateY(0);
        }

        .about-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .about-label {
          font-size: 0.85rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.2em;
          color: var(--accent-primary);
          margin-bottom: 1rem;
          display: block;
          user-select: none;
        }

        .about-title {
          font-size: clamp(2.5rem, 5vw, 4rem);
          font-weight: 900;
          line-height: 1.1;
        }

        .programs-section {
          margin-bottom: 3rem;
          text-align: center;
        }

        .programs-line {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          justify-content: center;
        }

        .program-item {
          padding: 0.5rem 1rem;
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.8) 0%,
            rgba(255, 255, 255, 0.5) 100%
          );
          backdrop-filter: blur(15px);
          -webkit-backdrop-filter: blur(15px);
          border-radius: var(--radius-full);
          font-size: 0.8rem;
          font-weight: 500;
          transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          box-shadow: 
            0 2px 10px rgba(0, 0, 0, 0.06),
            inset 0 1px 1px rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(255, 255, 255, 0.6);
          cursor: none;
          opacity: 0;
          transform: translateY(10px);
        }

        .about-section.visible .program-item {
          opacity: 1;
          transform: translateY(0);
          animation: fadeInUp 0.4s ease forwards;
          animation-delay: var(--delay);
        }

        .program-item:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 
            0 10px 25px rgba(139, 92, 246, 0.2),
            inset 0 1px 1px rgba(255, 255, 255, 0.9);
          color: var(--accent-primary);
          border-color: rgba(139, 92, 246, 0.3);
        }

        .program-item:active {
          transform: scale(0.95);
        }

        .clients-section {
          text-align: center;
          margin-bottom: 3rem;
          padding: 3rem 0;
        }

        .clients-section h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 2.5rem;
        }

        .clients-grid-new {
          display: grid;
          grid-template-columns: repeat(4, 140px);
          gap: 1.5rem;
          justify-content: center;
          align-items: center;
          max-width: 900px;
          margin: 0 auto;
          padding: 2rem;
        }

        @media (max-width: 700px) {
          .clients-grid-new {
            grid-template-columns: repeat(3, 110px);
            gap: 1rem;
          }
        }

        @media (max-width: 450px) {
          .clients-grid-new {
            grid-template-columns: repeat(2, 100px);
            gap: 0.75rem;
          }
        }

        .client-circle-new {
          position: relative;
          width: 140px;
          height: 140px;
          border-radius: 50%;
          cursor: none;
          transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          will-change: transform;
        }

        @media (max-width: 700px) {
          .client-circle-new {
            width: 110px;
            height: 110px;
          }
        }

        @media (max-width: 450px) {
          .client-circle-new {
            width: 100px;
            height: 100px;
          }
        }

        .client-circle-new img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          transition: box-shadow 0.35s ease, filter 0.35s ease;
        }

        .client-circle-new:hover img {
          box-shadow: 0 20px 50px rgba(139, 92, 246, 0.5);
          filter: brightness(1.05);
        }

        .client-name-new {
          position: absolute;
          bottom: -45px;
          left: 50%;
          transform: translateX(-50%);
          background: var(--text-primary);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 600;
          white-space: nowrap;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          animation: fadeInName 0.2s ease;
        }

        @keyframes fadeInName {
          from { opacity: 0; transform: translateX(-50%) translateY(5px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }

        .about-bio-section {
          text-align: center;
          padding-top: 2rem;
          border-top: 1px solid rgba(0,0,0,0.08);
        }

        .about-bio {
          font-size: 1.05rem;
          line-height: 1.9;
          color: var(--text-secondary);
          max-width: 550px;
          margin: 0 auto;
        }

        /* Footer */
        .footer {
          padding: 3rem 2rem;
          background: var(--bg-secondary);
          text-align: center;
        }

        .footer p {
          font-size: 0.9rem;
          color: var(--text-secondary);
        }

        /* Modal */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(26, 26, 26, 0.92);
          backdrop-filter: blur(10px);
          z-index: 2000;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          animation: fadeIn 0.3s ease;
          cursor: none;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .modal-content {
          width: 100%;
          max-width: 950px;
          background: linear-gradient(
            145deg,
            rgba(255, 255, 255, 0.98) 0%,
            rgba(255, 255, 255, 0.92) 100%
          );
          backdrop-filter: blur(40px) saturate(180%);
          -webkit-backdrop-filter: blur(40px) saturate(180%);
          border-radius: var(--radius-lg);
          position: relative;
          animation: modalSlide 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
          overflow: hidden;
          box-shadow: 
            0 25px 80px rgba(0, 0, 0, 0.25),
            0 0 0 1px rgba(255, 255, 255, 0.5) inset;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }

        @keyframes modalSlide {
          from { opacity: 0; transform: translateY(50px) scale(0.9); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        .modal-close {
          position: absolute;
          top: -3.5rem;
          left: 0;
          width: 48px;
          height: 48px;
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.25) 0%,
            rgba(255, 255, 255, 0.1) 100%
          );
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          color: #fff;
          cursor: none;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        }

        .modal-close:hover {
          background: linear-gradient(
            135deg,
            rgba(139, 92, 246, 0.8) 0%,
            rgba(109, 40, 217, 0.8) 100%
          );
          transform: rotate(90deg);
          border-color: rgba(139, 92, 246, 0.5);
        }

        .modal-close:active {
          transform: rotate(90deg) scale(0.9);
        }

        .modal-close svg {
          width: 22px;
          height: 22px;
        }

        .video-container {
          aspect-ratio: 16/9;
          width: 100%;
          border-radius: var(--radius-lg) var(--radius-lg) 0 0;
          overflow: hidden;
        }

        .video-container iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        .modal-info {
          padding: 2rem;
        }

        .modal-info h3 {
          font-size: 1.75rem;
          font-weight: 700;
          margin-bottom: 0.75rem;
        }

        .modal-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .modal-info p {
          color: var(--text-secondary);
          line-height: 1.8;
          font-size: 1rem;
        }
      `}</style>

      <CustomCursor />
      
      {/* Compact Navbar */}
      <nav className={`navbar ${showNavbar ? 'visible' : ''}`}>
        <div className="navbar-content">
          <div className="navbar-logo" data-hover onClick={() => scrollToSection('top')}>
            <img src={LOGO_URL} alt="Logo" className="navbar-logo-img" />
          </div>
          <div className="navbar-divider" />
          <div className="navbar-links">
            <button className="nav-link" onClick={() => scrollToSection('works')} data-hover>
              <span className="nav-link-text">עבודות</span>
              <span className="nav-link-line" />
            </button>
            <button className="nav-link" onClick={() => scrollToSection('about')} data-hover>
              <span className="nav-link-text">אודות</span>
              <span className="nav-link-line" />
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg" ref={heroRef}>
          <div className="hero-gradient hero-gradient-1" />
          <div className="hero-gradient hero-gradient-2" />
          
          {/* Floating animated shapes */}
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
            <div className="shape shape-6"></div>
          </div>
          
          {/* Animated lines */}
          <div className="hero-lines">
            <div className="hero-line line-1"></div>
            <div className="hero-line line-2"></div>
            <div className="hero-line line-3"></div>
          </div>
          
          {/* Glowing orbs */}
          <div className="glow-orb orb-1"></div>
          <div className="glow-orb orb-2"></div>
          <div className="glow-orb orb-3"></div>
        </div>
        <div className="hero-content">
          <InteractiveLogo src={LOGO_URL} />
          <p className="hero-subtitle">
           היי, אני עידן שביט, אפטריסט,<br />
            עורך וידאו ותלת
            מקצועי כבר למעלה מ־5 שנים.
          </p>


          <div className="start-button-wrapper">
            <PopButton onClick={() => scrollToSection('works')}>
              <span>לצפייה בעבודות</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 5v14M5 12l7 7 7-7" />
              </svg>
            </PopButton>
          </div>
        </div>
        <div className="scroll-hint">
          <span>גלול</span>
          <div className="scroll-hint-line" />
        </div>
      </section>

      {/* Projects Section */}
      <section id="works" className="projects-section">
        <div className="section-header">
          <h2>
            <InteractiveTitle>עבודות נבחרות</InteractiveTitle>
          </h2>
          <p>העבודות הנבחרות שלי, עם אפטר, תלת ועריכה ברמה יוצאת דופן.</p>
        </div>
        
        {/* Showreel Button */}
        <div className="showreel-container">
          <button 
            className="showreel-button"
            onClick={() => setSelectedProject({ 
              title: "Showreel", 
              youtubeId: "pNrzngBUg44",
              tags: ["שואוריל"],
              description: "השואוריל שלי - אוסף העבודות הטובות ביותר"
            })}
            data-hover
          >
            <div className="showreel-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
            <span>צפה בשואוריל</span>
            <div className="showreel-shine" />
          </button>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <ProjectCard
              key={project.id}
              project={project}
              index={index}
              onClick={() => setSelectedProject(project)}
            />
          ))}
        </div>
      </section>

      {/* About Section */}
      <AboutSection />

      {/* Footer */}
      <footer className="footer">
        <p>© 2025 · עידן שביט</p>
      </footer>

      {/* Video Modal */}
      {selectedProject && (
        <VideoModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      )}
    </>
  );
}